export default __webpack_public_path__ + "static/media/colombia.a49d6cac.svg";